import { render } from "./PositionGrid.vue?vue&type=template&id=2d1c0d3e&scoped=true"
import script from "./PositionGrid.vue?vue&type=script&lang=ts"
export * from "./PositionGrid.vue?vue&type=script&lang=ts"

import "./PositionGrid.vue?vue&type=style&index=0&id=2d1c0d3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d1c0d3e"

export default script